module.exports = new __parcel__URL__("meta.1519cc4e.png").toString();